import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface SourceContact {
  id?: number;
  //sourceId: number;
  title?: string;
  name: string;
  position?: string;
  phones?: string;
  email?: string;
  comments?: string;
  order: number;
  status: string;
}

@Injectable({ providedIn: 'root' })
export class SourceContactsService {

  private http = inject(HttpClient);

  private baseUrl = `${environment.apiUrl}/api/source-contacts`;

  getBySource(sourceId: number): Observable<SourceContact[]> {
    return this.http.get<SourceContact[]>(`${this.baseUrl}/source/${sourceId}`);
  }

  create(dto: SourceContact, userId: number): Observable<string> {
    const params = new HttpParams().set('userId', userId);
    return this.http.post(`${this.baseUrl}`, dto, {
      params,
      responseType: 'text'
    });
  }

  update(dto: SourceContact, userId: number): Observable<string> {
    const params = new HttpParams().set('userId', userId);
    return this.http.put(`${this.baseUrl}`, dto, {
      params,
      responseType: 'text'
    });
  }

  deactivate(id: number, userId: number): Observable<string> {
    const params = new HttpParams().set('userId', userId);
    return this.http.delete(`${this.baseUrl}/${id}`, {
      params,
      responseType: 'text'
    });
  }
}
